import SignalR from '@/libs/signalR/vuexStore/storeActions';

const ACTIONS = {
  // Store Actions
  SET_TOKEN: 'setToken',
  CLEAR_STATE: 'clearState',
  SET_SNACKBAR: 'setSnackbar',

  // User Actions
  SET_USER: 'setUser',
  SET_TIMETABLE: 'setTimeTable',
  UPDATE_TIMETABLE: 'updateTimeTable',
  SET_USER_LOADINGSTATE: 'setUserLoadingState',

  // Run Actions
  SET_RUN_INFO: 'setRunInfo',
  SET_RUN_STATE: 'setRunState',
  UPDATE_RUN_STATE: 'updateRunState',
  SET_RUN_INFO_LOADINGSTATE: 'setRunInfoLoadingState',
  SET_CURRENT_EXERCISE: 'setCurrentExercise',
  SET_OPEN_EXERCISE_ID: 'setOpenExerciseId',
  SET_RUN_DOCUMENTS: 'setRunDocuments',
  SET_PARTICIPANT_EXERCISE_STATUS_LOADINGSTATE: 'setParticipantExerciseStatusLoadingState',
  SET_PARTICIPANT_RUN_INFO: 'setParticipantRunInfo',
  SET_PARTICIPANT_STATUS: 'setParticipantStatus',

  //CandidateNotes - those dont get persistent on server which is why we dont need a loading state
  ADD_NOTE: 'addNote',
  REMOVE_NOTE: 'removeNote',
  UPDATE_NOTE: 'updateNote',

  // ExerciseDocuments
  SET_CURRENT_EXERCISE_DOCUMENTS: 'setCurrentExerciseDocuments',
  SET_CURRENT_EXERCISE_DOCUMENTS_LOADING_STATE: 'setCurrentExerciseDocumentsLoadingState',

  // import the signalR Store Actions
  ...SignalR
}

export default ACTIONS;
